import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_BALANCE_CORRECTIONS_LIST_ROUTE_NAME,
  BALANCE_CORRECTIONS_PERMISSIONS,
  TRANSLATION_GROUP_BALANCE_CORRECTIONS,
} from './constants';
import { getTranslationKeys } from './translations';

export class BalanceCorrectionsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_BALANCE_CORRECTIONS_LIST_ROUTE_NAME,
      path: 'adjustments-history',
      permission: BALANCE_CORRECTIONS_PERMISSIONS.SHOW,
      component: () => import('./pages/BalanceCorrectionsListPage/BalanceCorrectionsListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_ADMIN_BALANCE_ADJUSTMENTS_HISTORY'),
      to: {
        name: ADMIN_BALANCE_CORRECTIONS_LIST_ROUTE_NAME,
      },
      permission: BALANCE_CORRECTIONS_PERMISSIONS.SHOW,
      id: ADMIN_BALANCE_CORRECTIONS_LIST_ROUTE_NAME,
      order: 100,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_BALANCE_CORRECTIONS, getTranslationKeys);
  }
}
